import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
// Accept either name. Netlify/Flutter may use publishable key, older docs use anon key.
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
const OLD_SUPABASE_PROJECT = 'uasrwwdrkxzabpyqqguv'

const projectRef = supabaseUrl?.match(/https:\/\/([^.]+)\.supabase\.co/)?.[1] ?? 'unknown'

console.log('[Supabase] Project:', projectRef, '| URL:', supabaseUrl)

if (supabaseUrl?.includes(OLD_SUPABASE_PROJECT)) {
  console.error(
    '[Supabase] WRONG PROJECT: This build is still using the deprecated database.',
    'Update Netlify env vars to eqpuxpdtyfprzbrbswop and redeploy with cache cleared.'
  )
}

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables')
  console.error('VITE_SUPABASE_URL:', supabaseUrl)
  console.error('VITE_SUPABASE_ANON_KEY:', import.meta.env.VITE_SUPABASE_ANON_KEY)
  console.error('VITE_SUPABASE_PUBLISHABLE_KEY:', import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY)
  throw new Error(
    'Missing Supabase environment variables. Set VITE_SUPABASE_URL and either VITE_SUPABASE_ANON_KEY or VITE_SUPABASE_PUBLISHABLE_KEY.'
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
